<template>
  <i class="icon" v-html="html"></i>
</template>

<script>
  import { app } from '@/axios';

  const icons = {};
  const regex = /<[svg][^>]*>(.*)<\/svg>/;

  export default {
    props: {
      icon: {
        type: String,
        required: true
      },
    },

    data: () => ({
      html: null,
    }),

    watch: {
      icon () {
        this.load();
      },
    },

    created () {
      this.load();
    },

    methods: {
      async load () {
        if (! icons[this.icon]) {
          icons[this.icon] = app.get(`icon/${this.icon.toLowerCase()}.svg`)
            .then(({ data }) => data);
        }

        this.html = await icons[this.icon];
      },
    },
  }
</script>

<style lang="scss">
  .icon {
    display: flex;

    svg {
      width: 100%;
    }
  }
</style>
